module.exports = __webpack_public_path__ + "img/1970East-018_WEB-min.3b342942.jpg";